import React from 'react';


export default ({color, onClick, size}) => {
  return (
    <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={size || 18} height={size || 18} viewBox="0 0 18 18">
      <path fill={color || '#0092e5'} d="M149,460a9,9,0,1,0,9,9A9,9,0,0,0,149,460Zm0,16.2a7.2,7.2,0,1,1,7.2-7.2A7.208,7.208,0,0,1,149,476.2Zm3.6-7.2a.9.9,0,0,1-.9.9h-1.8v1.8a.9.9,0,1,1-1.8,0v-1.8h-1.8a.9.9,0,1,1,0-1.8h1.8v-1.8a.9.9,0,1,1,1.8,0v1.8h1.8A.9.9,0,0,1,152.6,469Z" transform="translate(-140 -460)"/>
    </svg>
  )
}